import { connect } from 'react-redux'
import { VisualsHome } from './VisualsHome.component'

export default connect()(VisualsHome)
